<template>
  <FriedTableCell>
    <FriedParagraph v-if="!hidden" class="date">
      {{ formattedDate }}
    </FriedParagraph>
    <FriedParagraph v-if="!hidden && userName" class="name" :size="ParagraphSize.Small">
      {{ userName }}
    </FriedParagraph>
  </FriedTableCell>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { ParagraphSize } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';
import { DateTime } from 'luxon';
import { DateHelper } from '@getaccept/lib-shared/src/helpers/date.helper';

export default defineComponent({
  name: 'DateCell',
  props: {
    date: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const formattedDate = computed(() => {
      if (!props.date) {
        return '';
      }
      const isoDate = DateTime.fromISO(props.date);

      if (DateHelper.isToday(isoDate)) {
        return t('Today').toString();
      }
      if (DateHelper.isYesterday(isoDate)) {
        return t('Yesterday').toString();
      }

      return isoDate.toLocaleString({ ...DateTime.DATE_FULL });
    });

    return {
      ParagraphSize,
      formattedDate,
    };
  },
});
</script>

<style lang="scss" scoped>
.date {
  white-space: nowrap;
}

.name {
  color: var(--text-gray);
}
</style>
